export default [{
    key: "selected",
    label: "เลือกรายการ",
    class: "text-center"
},
{
    key: "shop_code",
    label: "รหัสร้าน",
    sortable: true
},
{
    key: "shop_name",
    label: "ชื่อร้าน",
    sortable: true
},
{
    key: "customer_type",
    label: "ประเภทร้านค้า",
    sortable: true
},
{
    key: "nums",
    label: "จำนวนพัสดุ",
    sortable: true
},
{
    key: "cod_amount",
    label: "ยอดรวม COD",
    sortable: true
},
{
    key: "commission",
    label: "ยอดรวม Commission",
    sortable: true
},
{
    key: "exclude_vat",
    label: "ยอด Commission ก่อน Vat 7%",
    sortable: true
},
{
    key: "withholding_tax",
    label: "หักภาษี ณ ที่จ่าย",
    sortable: true
},
{
    key: "net_commission",
    label: "Commission สุทธิ",
    sortable: true
}
]